/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { readString } from "react-papaparse";

/*COMPONENT*/
import SpinnerSimpleBlue from "../common_spinner/SpinnerSimpleBlue";
import Modal from "../common_modal/Modal";
import SEARCH_LAYER_JOIN from "./SEARCH_LAYER_JOIN";

/*REDUX*/
import {
  get_features_by_layer_id_without_reducer,
  importLayer,
} from "../../App/actions/layerNewActions";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/

/*FUNCTION*/
import isEmpty from "../../App/validation/is-empty";
import uuid from "../../App/validation/uuid";
import {
  generateFields,
  select_field_from_default_props,
} from "../../App/validation/generateGeoJson";
import { color_setup } from "../../App/validation/geojson_properties";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const lastIndex = 5;
const confirmIndex = 4;

/**
 * text_bold : Title
 * text_inferior : Description title
 */

const JOIN_TABLE = ({
  auth,
  project,
  importLayer,
  get_features_by_layer_id_without_reducer,
  post_activities,
}) => {
  const [header, setHeader] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [modal_status, setModalStatus] = useState(false);
  const [indexModal, setIndexModal] = useState(0);
  const [colSelected, setColSelected] = useState("");
  const [colImportSelected, setColImportSelected] = useState("");
  const [col_import_name, setColImportName] = useState("");
  const [dataSelected, setDataSelected] = useState("");
  const [layerName, setLayerName] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [successRow, setSuccessRow] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [notFoundCSV, setNotFoundCSV] = useState([]);
  const [user_id, setUserId] = useState("");

  const fileInput = useRef(null);

  useEffect(() => {
    if (auth?.user?._id) {
      setUserId(auth.user._id);
    }
  }, [auth.user]);

  const openWizard = () => {
    setModalStatus(!modal_status);
  };

  const closeWizard = () => {
    setHeader([]);
    setCsvData([]);
    setModalStatus(false);
    setIndexModal(0);
    setColSelected("");
    setColImportSelected("");
    setColImportName("");
    setDataSelected("");
    setLayerName("");
    setIsSuccess(false);
    setSuccessRow(0);
    setIsLoading(false);
    setNotFoundCSV([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const file = fileInput.current.files[0];
    if (!file) return;

    const fr = new FileReader();
    fr.addEventListener("load", () => {
      const res = fr.result;
      const parseRes = readString(res);
      setHeader(parseRes.data[0]);
      setCsvData(parseRes.data);
    });
    fr.readAsText(file);
  };

  const generateNewLayer = async () => {
    const { geo_project } = project;
    const params_body = {
      project_id: dataSelected?.geo_project?._id,
      geo_layer_id: dataSelected?._id,
      architecture: dataSelected?.architecture,
    };

    const features =
      await get_features_by_layer_id_without_reducer(params_body);

    let colIndex = header.findIndex((itm) => itm === colSelected);
    let type = dataSelected?.type;

    let csvDataCopy = [...csvData];
    csvDataCopy.shift();

    let notFoundCSVTemp = [];
    let featuresItem = features.map((ft) =>
      String(ft.properties[colImportSelected]).toLowerCase(),
    );

    csvDataCopy.forEach((dt) => {
      let searchRes = featuresItem.includes(String(dt[colIndex]).toLowerCase());
      if (!searchRes) {
        notFoundCSVTemp.push(dt[colIndex]);
      }
    });

    let newFeatures = csvDataCopy
      .filter((dt) => {
        const itm = features.find(
          (ft) =>
            String(ft.properties[colImportSelected]).toLowerCase() ===
            String(dt[colIndex]).toLowerCase(),
        );
        return !isEmpty(itm);
      })
      .map((dt) => {
        let originFeature = features.find(
          (ft) =>
            String(ft.properties[colImportSelected]).toLowerCase() ===
            String(dt[colIndex]).toLowerCase(),
        );

        let newProps = {};
        header.forEach((h, idx) => {
          newProps[h] = dt[idx];
        });

        if (!isEmpty(originFeature)) {
          return {
            ...originFeature,
            properties: {
              ...originFeature.properties,
              ...newProps,
            },
          };
        }
        return originFeature;
      })
      .filter((x) => x);

    let newGeojson = {
      type: "FeatureCollection",
      features: newFeatures,
    };

    setIsSuccess(newFeatures.length > 1);
    setSuccessRow(newFeatures.length);
    setNotFoundCSV(notFoundCSVTemp);

    if (newFeatures.length < 1) {
      increaseIndex();
      setIsLoading(false);
      return;
    }

    //Generate Fields
    let fields_ori = generateFields(header);
    const fields_default = select_field_from_default_props(type);
    let new_fields = fields_default.concat(fields_ori);

    // mencari field
    const cari_index = (field) =>
      new_fields.findIndex((field_element) => field_element.key === field.key);
    new_fields = new_fields.filter(
      (field, index) => cari_index(field) === index,
    );

    //GENERATE GEOJSON
    let generatedGeojson = {};
    const generatedFeatures = newGeojson.features.map((feature, idx) => {
      const geometry_type = feature?.geometry?.type
        ? feature?.geometry?.type
        : "Polygon";
      const prop_default = color_setup({
        feature,
        geometry_type,
        idx,
      });
      const prop_ori = feature.properties;
      const properties = Object.assign({}, prop_default, prop_ori);

      return {
        key: uuid(),
        type: feature.type,
        properties,
        geometry: feature.geometry
          ? feature.geometry
          : { type: "Polygon", coordinates: [] },
        isHide: false,
      };
    });

    generatedGeojson.features = generatedFeatures;
    generatedGeojson.type = "FeatureCollection";

    const body = {
      name: layerName,
      description: layerName,
      user_id,
      geo_project_id: geo_project.link,
      folder: "",
      geojson: generatedGeojson,
      type,
      fields: new_fields,
      properties: fields_default,
    };

    importLayer(body);
    setIsLoading(false);
    increaseIndex();

    post_activities({
      action: "join_table",
    });
  };

  const setSelectedData = (layer) => {
    setDataSelected(layer);
  };

  const increaseIndex = () => {
    setIndexModal((prev) => prev + 1);
  };

  const decreaseIndex = () => {
    setIndexModal((prev) => prev - 1);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //content
  const page0 = (
    <div>
      <div className="text_bold">{dict["Select File"][language]}</div>
      <div className="text_inferior" style={{ marginBottom: "10px" }}>
        {
          dict[
            "Please give your new layer a name, and select a .csv file to joined with public data on MAPID."
          ][language]
        }
      </div>
      <div>
        <input
          type="text"
          value={layerName}
          placeholder={dict["Layer name"][language]}
          onChange={(e) => setLayerName(e.target.value)}
          data-mapid="inputLayer"
        />
      </div>
      <div>
        <input
          type="file"
          accept=".csv"
          ref={fileInput}
          onChange={handleSubmit}
          data-mapid="uploadFileJoin"
        />
      </div>
    </div>
  );

  const page1 = (
    <div>
      <div className="text_bold">{dict?.["Select column"]?.[language]}</div>
      <div className="text_inferior" style={{ marginBottom: "10px" }}>
        {
          dict[
            "Please select a column from your .csv file to set it as a parameter."
          ][language]
        }
      </div>
      <div>
        <table>
          <tbody>
            {header.map((col, idx) => (
              <tr key={`col-param-${idx}`}>
                <td>
                  <input
                    type="radio"
                    name="param"
                    id={`col-param-${idx}`}
                    checked={colSelected === col}
                    value={col}
                    onChange={(e) => setColSelected(e.target.value)}
                    data-mapid={`selectRadio-${idx}`}
                  />
                </td>
                <td>
                  <label htmlFor={`col-param-${idx}`}>{col}</label>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  //Pilih lyaer yang akan dijoin
  const page2 = (
    <div>
      <div className="box-body">
        <SEARCH_LAYER_JOIN selectData={setSelectedData} />
      </div>
    </div>
  );

  // Konfirmasi kolom yang dipilih dari data yang di Import
  const page3 = (
    <div>
      <div className="text_bold">{dict?.["Select column"]?.[language]}</div>
      <div className="text_inferior" style={{ marginBottom: "10px" }}>
        {
          dict[
            "Please select a column from selected public data to set it as a parameter."
          ][language]
        }
      </div>
      <table>
        <tbody>
          {dataSelected &&
            dataSelected?.fields
              ?.filter((x) => !x.isStyle)
              .map(({ key, name }, idx) => (
                <tr key={`col-param-selected-${idx}`}>
                  <td>
                    <input
                      type="radio"
                      name={name}
                      id={`col-param-${idx}`}
                      checked={colImportSelected === key}
                      value={key}
                      onChange={(e) => {
                        setColImportSelected(e.target.value);
                        setColImportName(e.target.name);
                      }}
                      data-mapid={`selectRadio-${idx}`}
                    />
                  </td>
                  <td>
                    <label htmlFor={`col-param-${idx}`}>{name}</label>
                  </td>
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );

  const page4 = (
    <div>
      <div className="text_bold">{dict["Confirmation"][language]}</div>
      <div className="text_inferior" style={{ marginBottom: "10px" }}>
        {dict["Please check again your selected data and column."][language]}
      </div>
      <div>
        <table>
          <tbody>
            <tr>
              <td>File name</td>
              <td>:</td>
              <td>{dataSelected.name}</td>
            </tr>
            <tr>
              <td>{dict["Selected column"][language]}</td>
              <td>:</td>
              <td>{colSelected}</td>
            </tr>
            <tr>
              <td>{dict["Selected public data column"][language]}</td>
              <td>:</td>
              <td>{col_import_name}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <div>
        <b>
          {
            dict["Are you sure want to generate data based that parameter?"][
              language
            ]
          }
        </b>
      </div>
    </div>
  );

  const page5 = isSuccess ? (
    <div>
      <div className="text_bold">{dict["Success"][language]}</div>
      <div>
        {dict["Layer is created."][language]}
        <br />
        {successRow} {dict["from"][language]} {csvData.length}{" "}
        {dict["row is generated."][language]}
        <br />
      </div>
      {notFoundCSV.length > 0 && (
        <div>
          {dict["Not generated features from CSV :"][language]}
          <div>
            <ul>
              {notFoundCSV.map((f, idx) => (
                <li key={`not-found-${idx}`}>{f}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div>
      <div className="text_bold">{dict["Failed"][language]}</div>
      <div>
        {dict["0 row generated."][language]}
        <br />
        {
          dict[
            "Please check your file,your selected column or selected data from MAPID"
          ][language]
        }
      </div>
    </div>
  );

  return (
    <main>
      <button
        className="button background_black margin_right"
        style={{ color: "white" }}
        onClick={openWizard}
        data-mapid="clickJoinTable"
      >
        {dict?.["Start Join Table"]?.[language]}
      </button>

      {modal_status && (
        <Modal
          modalSize="medium"
          id="modal"
          isOpen={modal_status}
          onClose={closeWizard}
        >
          <div className="box-body">
            {isLoading && (
              <div>
                <div className="text_bold">{dict["Loading"][language]}</div>
                <div className="text_inferior" style={{ marginBottom: "10px" }}>
                  {
                    dict["Please wait, your layer is now creating by system."][
                      language
                    ]
                  }
                </div>
                <SpinnerSimpleBlue
                  width={100}
                  unik="loading_create_layer"
                  border={0.1}
                  center={true}
                />
              </div>
            )}
            {indexModal === 0 && !isLoading && page0}
            {indexModal === 1 && !isLoading && page1}
            {indexModal === 2 && !isLoading && page2}
            {indexModal === 3 && !isLoading && page3}
            {indexModal === 4 && !isLoading && page4}
            {indexModal === 5 && !isLoading && page5}
          </div>
          <div
            style={{
              textAlign: "right",
              padding: 20,
              visibility: !isLoading ? "visible" : "hidden",
            }}
          >
            {indexModal === lastIndex && isSuccess ? (
              <div>
                <button
                  className="button background_black margin_right"
                  onClick={closeWizard}
                  data-mapid="clickFinish"
                >
                  {dict["Finish"][language]}
                </button>
              </div>
            ) : indexModal === lastIndex ? (
              <div>
                <button
                  className="button background_black margin_right"
                  onClick={decreaseIndex}
                >
                  {dict["Back"][language]}
                </button>
                <button
                  className="button background_black margin_right"
                  onClick={closeWizard}
                >
                  {dict["Cancel"][language]}
                </button>
              </div>
            ) : indexModal === confirmIndex ? (
              <div>
                <button
                  className="button background_black margin_right"
                  onClick={decreaseIndex}
                >
                  {dict["Back"][language]}
                </button>
                <button
                  className="button background_black margin_right"
                  onClick={() => {
                    setIsLoading(true);
                    generateNewLayer();
                  }}
                  data-mapid="clickYes"
                >
                  {dict["Yes"][language]}
                </button>
              </div>
            ) : (
              <div>
                <button
                  disabled={indexModal === 0}
                  className={
                    indexModal === 0
                      ? "button background_grey margin_right"
                      : "button background_black margin_right"
                  }
                  onClick={decreaseIndex}
                >
                  {dict["Back"][language]}
                </button>
                <button
                  disabled={
                    indexModal === lastIndex ||
                    (indexModal === 0 && isEmpty(header) && isEmpty(csvData)) ||
                    layerName === "" ||
                    (indexModal === 2 && dataSelected === "")
                  }
                  className={
                    indexModal === lastIndex ||
                    (indexModal === 0 && isEmpty(header) && isEmpty(csvData)) ||
                    layerName === "" ||
                    (indexModal === 2 && dataSelected === "")
                      ? "button background_grey margin_right"
                      : "button background_black margin_right"
                  }
                  onClick={increaseIndex}
                  data-mapid="clickNext"
                >
                  {dict["Next"][language]}
                </button>
              </div>
            )}
          </div>
        </Modal>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  importLayer,
  get_features_by_layer_id_without_reducer,
  post_activities,
})(JOIN_TABLE);
